module.exports = __webpack_public_path__ + "static/img/img_media01.979ab7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_mobile/img_media01.png
// module id = 33bR
// module chunks = 0